import { useEffect, useState } from "react";
import Api from "../openapi";
import type { SubscriptionResponse } from "../openapi/client";
import { IUser } from "../store/userSlice";
import { checkEmptyObj, checkIf } from "../utils";

export default function useSubscriptions(user: IUser, refresh?: number) {
  const [subscriptions, setSubscriptions] = useState<SubscriptionResponse[]>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getUserSubscriptions = async () => {
      try {
        setLoading(true);
        const res = await Api.Subscription.listSubscriptions();
        setSubscriptions(res.data);
      } catch (error) {}

      setLoading(false);
    };
    if (!checkEmptyObj(user)) {
      getUserSubscriptions();
    } else {
      setSubscriptions(undefined);
    }
  }, [refresh, user.phoneNumber]);
  return { subscriptions, loading };
}
